import { orderMessage } from "./model";
import { Subject } from "rxjs";

export const HeartbeatSubject = new Subject<string>();
export const OrderReportMessageSubject = new Subject<orderMessage>();
